import { mergeStyleSets, Theme } from '@fluentui/react';

export const getClassNames = (theme?: Theme, visibility?: boolean) => {
  const colors = theme?.palette;
  return mergeStyleSets({
    root: {
      width: visibility ? '30vh' : 60,
      backgroundColor: '#f0f0f0',
      height: 'calc(100vh - 50px)',
      overflowY: 'auto',
      overflowX: 'hidden',
      borderRight: '1px solid #e0e0e0',
      left: 0,
      top: 0,
      position: 'sticky',
    },
    searchBox: {
      margin: '16px 16px 8px',
    },
    separator: {
      borderTop: '1px solid #e0e0e0',
      margin: '8px 0 4px 0',
      paddingTop: '8px',
    },
    sectionHeader: {
      padding: '20px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      userSelect: 'none',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#FAFAFA',
      },
    },
    navItem: {
      padding: '6px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      userSelect: 'none',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#FAFAFA',
      },
    },
    navigationIcon: {
      marginLeft: 20,
      marginTop: 14,
      cursor: 'pointer',
    },
    sectionIcon: {
      size: 20,
      marginRight: 8,
      color: '#666',
    },
    chevronIcon: {
      marginLeft: 'auto',
    },
    sectionItems: {
      paddingLeft: 32,
    },
    itemText: {
      padding: '6px 0',
      cursor: 'pointer',
      userSelect: 'none',
      ':hover': {
        backgroundColor: '#f0f0f0',
      },
    },
    activeItemText: {
      padding: '6px 0',
      cursor: 'pointer',
      fontWeight: 600,
      userSelect: 'none',
    },
    normalText: {
      fontWeight: 'normal',
    },
    savedReportItem: {
      padding: '6px 16px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      userSelect: 'none',
      ':hover': {
        backgroundColor: '#f0f0f0',
      },
    },
    sectionLabel: {
      padding: '4px 16px',
      color: '#666666',
      fontSize: '12px',
      fontWeight: 600,
    },
    scheduleIcon: {
      right: 10,
      position: 'absolute',
    },
    defaultIcon: {
      right: 8,
      position: 'absolute',
      fontSize: 14,
      color: '#ffb900',
    },
    item: {
      padding: '6px 0',
      cursor: 'pointer',
    },
    activeItem: {
      padding: '6px 0',
      cursor: 'pointer',
      fontWeight: 600,
    },
    boldText: {
      fontWeight: 600,
    },
    selectedBar: {
      width: 4,
      height: 20,
      backgroundColor: colors?.blue,
      position: 'absolute',
      left: 4,
      borderRadius: 2,
    },
    icon: {
      marginRight: 16,
    },
    iconEmpty: {
      marginRight: 16,
      width: 20,
      height: 20,
    },
    circleIcon: {
      marginRight: 16,
    },
    itemName: {
      width: '20vh',
      overflow: 'hidden !important',
      textOverflow: 'ellipsis !important',
      whiteSpace: 'nowrap !important',
      textAlign: 'left',
      display: 'inline-block',
    },
  });
};
